import { useNavigate } from "react-router-dom";
import { homepageData } from "@/mocks/homeData";
import { useEntranceAnimation } from "@/hooks/useEntranceAnimation";

export default function BottomCtaSection() {
  const navigate = useNavigate();
  const { bottomCta } = homepageData;
  const { ref, isVisible } = useEntranceAnimation({ threshold: 0.15, sectionIndex: 3 });

  return (
    <section
      ref={ref}
      className="relative overflow-hidden flex items-center justify-center"
      style={{ minHeight: "100svh" }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Warm%20inviting%20abstract%20composition%20with%20layered%20open%20book%20pages%20radiating%20soft%20golden%20light%20from%20center%2C%20delicate%20curved%20pages%20spreading%20outward%20like%20wings%20in%20rich%20burgundy%20and%20deep%20amber%20tones%2C%20gentle%20book%20page%20textures%20and%20faint%20typographic%20lines%20blending%20into%20warm%20dark%20background%2C%20ethereal%20reading%20experience%20atmosphere%2C%20purely%20artistic%20and%20non-photographic%2C%20dramatic%20contrast%20with%20abundant%20warm%20light%20emanating%20from%20central%20focal%20point&width=1600&height=900&seq=qh-cta-brand-01&orientation=landscape&nocache=true')",
        }}
      />
      <div className="absolute inset-0 bg-white/20" />
      <div className="relative z-10 text-center px-4 w-full">
        <div
          className={`transition-all duration-[600ms] ease-out ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
          style={{ transitionDelay: "0ms" }}
        >
          <h2
            className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 max-w-2xl mx-auto tracking-wide leading-tight"
          >
            {bottomCta.title}
          </h2>
        </div>

        <div
          className={`mt-4 md:mt-6 transition-all duration-[600ms] ease-out ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
          style={{ transitionDelay: "100ms" }}
        >
          <p
            className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed"
          >
            {bottomCta.description}
          </p>
        </div>

        <div
          className={`mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 transition-all duration-[600ms] ease-out ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
          style={{ transitionDelay: "200ms" }}
        >
          {bottomCta.buttons.map((btn) => (
            <button
              key={btn.label}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(btn.href);
              }}
              className="px-6 py-3 text-sm font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600"
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}